import React from 'react';

import {Stack, Typography} from '@mui/material';
import {translations} from 'presentation/translations-new';

import {AlertInfo} from 'presentation/components';
import {EmptySelfNetworkAlertProps} from './types';

const {selfNetwork} = translations['pt-br'].privateFlow.bookingFlow.unitsFlow;

export function EmptySelfNetworkAlert({description}: EmptySelfNetworkAlertProps) {
	return (
		<Stack gap={1}>
			<Typography variant="subtitle1" color="text.secondary" fontWeight={600}>
				{selfNetwork.title}
			</Typography>
			<AlertInfo.Root>
				<AlertInfo.Description>{description}</AlertInfo.Description>
			</AlertInfo.Root>
		</Stack>
	);
}
